import { Star } from "lucide-react";

export const Stars = ({ value = 0, count, size = "w-3.5 h-3.5", className = "" }) => (
  <div className={`flex items-center gap-1 ${className}`} data-testid="star-rating" aria-label={`${value} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-[#D4AF37] text-[#D4AF37]" : "text-slate-300"}`} />
    ))}
    {count != null && <span className="text-xs text-slate-500 ml-1">{value} ({count})</span>}
  </div>
);
